import { Mapper } from "../../../../../core/base";
import { GetPrivateLocationWebEntity } from "./get-private-location-web-entity";
import { GetPrivateLocationsResponse } from "master-locations-library/master-locations-library/src/lib/core/domain/models/get-private-location.model";
import { LocationWebRepositoryMapper } from "./location.web-repository-mapper";
import { Location } from "master-locations-library/master-locations-library/src/lib/core/domain/models";
import { LocationWebEntity } from "./location-web-entity";

export class GetPrivateLocationWebRepositoryMapper extends Mapper<GetPrivateLocationWebEntity, GetPrivateLocationsResponse> {
  mapFrom(param: GetPrivateLocationWebEntity): GetPrivateLocationsResponse {
    const locationWebEntityMapper = new LocationWebRepositoryMapper();
    const locationsList: Location[] = [];
    param.privateLocations?.forEach((location) => {
      const mappedLocation = locationWebEntityMapper.mapFrom(location);
      locationsList.push(mappedLocation);
    });
    return {
      totalLocations: param.totalLocations,
      privateLocations : locationsList    
    };
  }

  mapTo(param: GetPrivateLocationsResponse): GetPrivateLocationWebEntity {
    const locationWebEntityMapper = new LocationWebRepositoryMapper();
    const locationsList: LocationWebEntity[] = [];
    param.privateLocations?.forEach((location) => {
      const mappedLocation = locationWebEntityMapper.mapTo(location);
      locationsList.push(mappedLocation);
    });
    return {
        totalLocations: param.totalLocations,
        privateLocations : locationsList    
      };
  }
}
